export const TOTAL_DAYS_UNTIL_SUSPENSION = 21
export const START_THREATEN_DAY = 7
